// components/RouteAuth.tsx or protect/RouteAuth.tsx
import { Navigate } from 'react-router-dom';
import { useStore } from '@/store/useStore';
import { auth, messaging } from '@/lib/firebase';

import { ReactNode, useEffect, useState } from 'react';

const RouteAuth = ({ children }: { children: ReactNode }) => {
  const user = useStore((state) => state.user);
  const [currentUser, setCurrentUser] = useState(user);

  useEffect(() => {
    setCurrentUser(user);
  }, [user])

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default RouteAuth;